import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updateBrandRpcContract = rpcContract({
  name: "updateBrand",
  paramsSchema: v.object({
    brandId: v.string(),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
    fileId: v.optional(v.string()),
    metaPixelId: v.optional(v.string()),
  }),
  resultSchema: v.object({
    id: v.string(),
    name: v.string(),
    thumbnail: v.nullable(v.string()),
    hasMetaPixel: v.boolean(),
  }),
});

export type UpdateBrandParams = v.InferOutput<(typeof updateBrandRpcContract)["paramsSchema"]>;
export type UpdateBrandResult = v.InferOutput<(typeof updateBrandRpcContract)["resultSchema"]>;
